export default "__VITE_ASSET__CbsiCFLI__"